





















































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { FivGoalModel, IFivGoal } from 'admiral-core';
import { CalendarIcon, CircleIcon, DiscIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import AgencyForm from '@/forms/AgencyForm.vue';
import { AgencyApi } from '@/services/AgencyApi';
import { BModal, BvModalEvent } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import { FivApi } from '@/services/FivApi';
import FivGoalForm from '@/forms/FivGoalForm.vue';

@Component({
  components: {
    FivGoalForm,
    FormSubmit,
    AgencyForm,
    CircleIcon,
    DiscIcon,
    CalendarIcon,
    XIcon,
  },
})
export default class EditFivGoalModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ required: true, type: Object })
  selectedFivGoal!: IFivGoal;

  model = this.defaultModel();

  defaultModel(): FivGoalModel {
    return {
      ...this.selectedFivGoal,
    };
  }

  @Watch('selectedFivGoal')
  watchSelectedFivGoal() {
    this.model = {
      ...this.selectedFivGoal,
    };
  }

  async mounted() {
    this.$root.$on('bv::modal::hide', async (bvEvent: BvModalEvent, modalId: string) => {
      if (modalId === 'edit-fiv-goal' && bvEvent.trigger === 'esc') {
        await this.cancel();
      }
    });
  }

  async destroyed() {
    this.$root.$off('bv::modal::hide');
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await FivApi.updateGoal(this.model.id!, {
        name: this.model.name!,
        products: this.model.products!,
        valueType: this.model.valueType!,
        agencyValue: Number(this.model.agencyValue),
      });

      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$toastr.s(`Ziel ${this.model.name} erfolgreich bearbeitet.`, 'Agentur bearbeitet');
      this.$nextTick(() => {
        (this.$refs['edit-fiv-goal'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Agentur ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['nameisNotEmpty'], 'name', 'Bitte einen gültigen Namen eingeben.');

    this.addError(
      apiErrors['identifierisNotEmpty'],
      'identifier',
      'Bitte eine gültige ID eingeben',
    );

    this.addError(apiErrors['Existing'], 'identifier', 'Agentur existiert bereits');
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }

  cancelDeletion() {
    //
  }

  async confirmDeletion() {
    try {
      await AgencyApi.delete(this.model.id!, { agency: this.model });

      (this.$refs['edit-agency'] as BModal).hide();
      this.$emit('reload');

      this.$toastr.s(`Agentur ${this.model.name} erfolgreich gelöscht.`, 'Agentur gelöscht');
    } catch (e) {
      this.$toastr.e('Beim Löschen der Agentur ist etwas schief gelaufen.');
      throw e;
    }
  }
}
